import BreachEvent from './breach';
import BaseEvent from './base_event';

const MINIGAME_WIDTH = 70;
const MINIGAME_HEIGHT = 10;

const PIX = 6;

class AsteroidsGame {
    constructor(x, y, stopCb) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'AsteroidsGame');

        this.bitmap = game.add.bitmapData(MINIGAME_WIDTH * PIX, MINIGAME_HEIGHT * PIX);
        this.sprite = game.add.sprite(x + 40, y, this.bitmap);
        this.ship = {
            x: 1, y: 5
        };
        this.asteroids = [];
        this.totalLeft = 70;
        for (let i = 0; i < MINIGAME_WIDTH - 10; i++) {
            this.proceedAsteroids();
        }
        this.stopCb = stopCb;
        this.redraw();
    }

    proceedAsteroids() {
        for (let a of this.asteroids) {
            a.x = a.x - Math.ceil(a.size / 2);
            if (this.collide(this.ship, a)) {
                return this.stopCb(true);
            }
        }
        this.asteroids = this.asteroids.filter(a => a.x >= 0);
        for (let y = 0; y < MINIGAME_HEIGHT; y++) {
            if (this.totalLeft > 0 && game.rnd.frac() < 0.1) {
                let size = 1;
                let sizeFactor = game.rnd.frac();
                /*if (sizeFactor < 0.2 && y < MINIGAME_HEIGHT-3) {
                    size = 3;
                } else */if (sizeFactor < 0.4 && y < MINIGAME_HEIGHT - 2) {
                    size = 2;
                }
                this.asteroids.push({ x: MINIGAME_WIDTH - 1, y, size });
                this.totalLeft--;
            }
        }
    }

    collide(ship, asteroid) {
        return asteroid.y <= ship.y && asteroid.y + asteroid.size >= ship.y + 1 && asteroid.x <= ship.x && asteroid.x + asteroid.size >= ship.x + 1;
    }

    updateInput(cursors, keys) {
        if (cursors.down.justDown) {
            if (this.ship.y < MINIGAME_HEIGHT - 2) this.ship.y++;
            this.proceedAsteroids();
            this.redraw();
        } else if (cursors.up.justDown) {
            if (this.ship.y > 1) this.ship.y--;
            this.proceedAsteroids();
            this.redraw();
        }
        if (this.totalLeft <= 0 && this.asteroids.length == 0) {
            this.stopCb(false);
        }

    }

    redraw() {
        let ctx = this.bitmap.ctx;
        ctx.fillStyle = "#444";
        ctx.fillRect(0, 0, this.bitmap.width, this.bitmap.height);
        ctx.strokeStyle = "#ccc";
        ctx.lineWidth = PIX;
        ctx.strokeRect(PIX / 2, PIX / 2, this.bitmap.width - PIX, this.bitmap.height - PIX);
        ctx.fillStyle = "#2680A9";
        ctx.fillRect(this.ship.x * PIX, this.ship.y * PIX, PIX, PIX);
        ctx.fillStyle = "#ccc";
        for (let a of this.asteroids) {
            ctx.fillRect(a.x * PIX, a.y * PIX, a.size * PIX, a.size * PIX);
        }
        this.bitmap.dirty = true;
    }


}

export default class AsteroidsEvent extends BaseEvent {

    static get game() {
        return AsteroidsGame;
    }

    static canOccur(gameState) {
        return !gameState.eventsResults.asteroids;
    }

    enter(gameState) {
        gameState.eventsResults.asteroids = true;
        this.ui.showDialog({
            message:
            `Your danger radar beeps and you see a huge asteroid field looming ahead. 
             Unfortunately, closest safe passage is 2 LY away. 
             If only your ship could move in three dimensions…`,
            options: [{
                text: "Let’s go through. My* nav computer* can handle this",
                condition: gameState.has('navigator'),
                callback: () => {
                    if (!BreachEvent.canOccur(gameState, this) || game.rnd.frac() < 0.5) {
                        gameState.distanceLeft -= 1;
                        gameState.history.push({ id: 'ast', msg: 'has got a PhD in a spaceworm anatomy'});
                        this.ui.showDialog({
                            message: `  
                            Your nav computer handled this like a boss. 
                            In fact, it even managed to cut you some fuel expenses on a shorter route through the giant space slug`,
                            status: "-1 Light Year"
                        }, this.end);
                    } else {
                        gameState.history.push({ id: 'ast', msg: 'has got an unlucky update popup'});
                        this.ui.showDialog({
                            message: `
                            Your nav computer prompts to upgrade its system to Portholes 10. 
                            While trying to close the annoying popup, you hear a loud bang...`,
                            status: "Asteroid impact!"
                        }, () => {
                            if (gameState.has('shield')) {
                                this.ui.showDialog({ message: `Your shield takes most of the damage, but some fragments still got through.` },
                                    () => this.schedule(BreachEvent, 0))
                            } else {
                                this.schedule(BreachEvent, 0);
                            }
                        })
                    }
                }
            }, {
                text: "I am a leaf on the wind. Watch how I soar.",
                callback: () => {
                    this.ui.showMinigame("Use up/down cursor keys to control your ship", AsteroidsGame, (hasBreak) => {
                        if (hasBreak) {
                            gameState.history.push({ id: 'ast', msg: 'overestimated his piloting skills in a harsh conditions'});
                            this.ui.showDialog({ message: "You hear a loud bang...", status: "Asteroid impact!" }, () => {
                                if (gameState.has('shield')) {
                                    this.ui.showDialog({ message: `Your shield takes most of the damage, but some fragments still got through.` },
                                        () => this.schedule(BreachEvent, 0))
                                } else {
                                    this.schedule(BreachEvent, 0);
                                }
                            })
                        } else {
                            gameState.history.push({ id: 'ast', msg: 'evaded asteroids like a champ'});
                            this.ui.showDialog({
                                message: `You’ve managed to made it in one piece, earning yourself a title 
                            of proficient asteroid evader and a huge 0.05% bonus to your salary! Congratulations!`}, this.end)
                        }
                    })
                }
            }, {
                text: "Let's fly the slow and safe route.",
                callback: () => {
                    gameState.distanceLeft += 2;
                    this.ui.showDialog({
                        message: `2 Light Years? That’s the second biggest asteroid field 
                        you’ve ever seen. But you know, the slower you go, the farther you 
                        will be. Farther from food, shelter and safety.`,
                        status: "+2 Light Years"
                    }, this.end)
                }
            }/*, {
                text: "AHAHAH",
                callback: () => {
                    this.schedule(BreachEvent, 0);
                }
            }*/]
        });
    }


}



// WEBPACK FOOTER //
// ./src/states/events/asteroids.js